import React from 'react'
function Product() {
  return (
    <>
    <div className='container'>
    <h1 className='text-center pt-5 pb-3'>Exclusive Products</h1>
    <div className="d-lg-block d-sm-none">
      <ul className='d-flex special justify-content-center pb-3'>
       <a href='facebook.com'><li className='pe-5 fw-semibold acti'>New Arrival</li></a>
       <a href='facebook.com'> <li className='pe-5 fw-semibold'>Best Sellers</li></a>
       <a href='facebook.com'><li className='pe-5 fw-semibold'>Featured</li></a>
       <a href='facebook.com'><li className='pe-5 fw-semibold'>Special Offer</li></a>   
       </ul>
       </div>
    </div>
    </>
  )
}

export default Product
